import { render, staticRenderFns } from "./SaveDashboard.vue?vue&type=template&id=7f100a4f&scoped=true"
import script from "./SaveDashboard.vue?vue&type=script&lang=js"
export * from "./SaveDashboard.vue?vue&type=script&lang=js"
import style0 from "./SaveDashboard.vue?vue&type=style&index=0&id=7f100a4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f100a4f",
  null
  
)

export default component.exports